module.exports = __webpack_public_path__ + "static/media/N2.a2af57ce.png";